

export default {
    name: 'employee-profile',
    props: {
        item: {
            type: Object,
            required: true
        },
        mode: {
            type: String,
            required: true
        }
    },
    components: {
    },
    created() {

        let t = this;

        t.initProfile();

        t.initConfig();

        t.loadData();

    },
    mounted() {
        let t = this;
        if (document.getElementById("realtimeStr4"))
            document.getElementById("realtimeStr4").innerText = new Date().format(
                "hh:mm:ss"
            );

        setInterval(function () {
            let t = new Date().format(
                "hh:mm:ss"
            );
            if (document.getElementById("realtimeStr4"))
                document.getElementById("realtimeStr4").innerText = t;
        }, 1000);

    },
    methods: {

        goCleanTasks() {
            this.view = 'clean-schedule';
            this.loadMonthlyStats();
        },

        goKPI() {
            let t = this;

            t.loadAttData();

            t.loadHalfYearAttData();

            t.view = 'att-kpi';
        },

        printA3() {

            if (window._printStyleTag) window._printStyleTag.remove();
            let style = `@media print { @page {  size: A3 landscape !important; } 
            .van-overlay{ background-color: #fff !important;} 
            .van-popup{ border:1px solid #333;}
            .employees-page{     overflow: hidden !important;}
            `;

            let s = document.createElement("style");
            s.innerHTML = style;
            document.body.appendChild(s);
            window._printStyleTag = s;
            window.print();
        },

        printA4() {
            if (window._printStyleTag) window._printStyleTag.remove();
            let style = `@media print { @page {  size: A3 landscape !important; } 
            .van-overlay{ background-color: #fff !important;} 
            .van-popup{ border:1px solid #333;}
            .employees-page{     overflow: hidden !important;}
            `;
            let s = document.createElement("style");
            s.innerHTML = style;
            document.body.appendChild(s);
            window._printStyleTag = s;
            window.print();
        },

        initProfile() {

            let t = this;

            t.list.country = window['COUNTRY_LIST'];

            t.list.country.forEach(item => {
                item.icon = 'assets/img/flag/' + item.code + '.svg';
            });

            t.dict.country = listToDict(t.list.country, 'code');


            t.dict.hire_type = listToDict(t.options.hire_type);
            t.dict.hire_type2 = listToDict(t.options.hire_type2);
            t.dict.hire_year = listToDict(t.options.hire_year);
            t.dict.rest_day = listToDict(t.options.rest_day);

            t.options.rest_day[5].selected = true;
            t.options.rest_day[6].selected = true;

            t.f.static_rest_day = [
                t.options.rest_day[5],
                t.options.rest_day[6]
            ];

            let arr = [];

            t.f.static_rest_day.forEach(item => {
                arr.push(item.text);
            });

            t.f.static_rest_day_text = arr.join('、');

            if (t.item) t.selectedDate = new Date(t.item.birthday);

            mirror2(t.item, t.f);

        },

        initConfig() {
            let t = this;

            let config = t.item.config;

            t.config = config;

            if (config.att_config && typeof config.att_config == 'string') {
                config.att_config = JSON.parse(config.att_config);
            }

            let days = config.static_rest_day;

            if (typeof days == 'string')
                days = days.split(',');

            if (days.length > 0) {

                t.f2.static_rest_day.forEach(item => {
                    item.selected = false;
                });
                t.f2.static_rest_day = [];
                t.f2.static_rest_day_text = '';

                let arr = [];
                let arr2 = [];

                days.forEach(day => {
                    if (t.dict.rest_day[day]) {
                        t.dict.rest_day[day].selected = true;
                        arr.push(t.dict.rest_day[day]);
                        arr2.push(t.dict.rest_day[day].text);
                    }
                });

                config.static_rest_day_text = arr2.join('、');

                config.static_rest_day = arr;
            }

            mirror(config, t.f2);

            if (t.item.birthday) {
                let arr = t.item.birthday.split('-');
                t.f.birthday_year = arr[0];
                t.f.birthday_month = arr[1];
                t.f.birthday_day = arr[2];
            }
        },

        async loadData() {
            let t = this;

            await axios.get('unit').then(res => {
                if (res.data.status == 1) {
                    let arr = res.data.options.items;
                    arr.forEach(item => {
                        item.text = item.name;
                    });
                    arr.unshift({ id: null, text: '無所属' });
                    t.options.unit = arr;
                    t.dict.unit = listToDict(arr);
                }
            });

            await axios.get('workGroup').then(res => {
                if (res.data.status == 1) {
                    let arr = res.data.options.items;
                    arr.forEach(item => {
                        item.text = item.name;
                    });
                    arr.unshift({ id: null, text: '無所属' });
                    t.options.workGroup = arr;
                    t.dict.workGroup = listToDict(arr);
                }
            });

        },

        closeCropper() {
            $("#cropperEmployeeProfile").hide();
        },

        confirmCropper() {
            let t = this;

            t.cropper
                .getCroppedCanvas({
                    minHeight: 600,
                    minWdith: 600,
                    maxHeight: 1000,
                    maxWdith: 1000,
                    fillColor: "#fff",
                })
                .toBlob((blob) => {
                    if (t.uploadImgType == 'rc') {
                        t.rcImageBlob = blob;
                        t.rcIsUploaded = true;
                        t.f.rc_img_url = getObjectURL(blob);
                    }

                    else if (t.uploadImgType == 'avatar') {
                        t.avatarImageBlob = blob;
                        t.avatarIsUploaded = true;
                        t.f.avatar_url = getObjectURL(blob);
                    }

                    t.closeCropper();
                });
        },

        uploadAvatar() {
            let t = this;

            t.uploadImgType = "avatar";

            ImageUploader.onSelectImage = (file) => {
                file = event.target["files"][0];

                var blobUrl = getObjectURL(file);

                const image = document.getElementById("cropperImgEmployeeProfile");

                image.src = blobUrl;

                if (t.cropper) {
                    t.cropper.destroy();
                    t.cropper = null;
                }

                image.onload = () => {
                    t.cropper = new Cropper(image, {
                        aspectRatio: 1 / 1,
                        autoCropArea: 1,
                        crop(event) { },
                    });
                    $("#cropperEmployeeProfile").show();
                };

                event.target["value"] = "";
            };

            ImageUploader.openSelector();
        },

        uploadRC() {

            let t = this;

            t.uploadImgType = 'rc';

            ImageUploader.onSelectImage = (file) => {

                file = event.target['files'][0];

                var blobUrl = getObjectURL(file);

                const image = document.getElementById('cropperImgEmployeeProfile');

                image.src = blobUrl;

                if (t.cropper) {
                    t.cropper.destroy();
                    t.cropper = null;
                }

                image.onload = () => {
                    t.cropper = new Cropper(image, {
                        aspectRatio: 4 / 3,
                        autoCropArea: 1,
                        crop(event) {
                        },
                    });
                    $('#cropperEmployeeProfile').show();
                }

                event.target['value'] = '';


            };

            ImageUploader.openSelector();
        },

        onSelectCountry(item) {
            this.f.country = item.code;
        },

        focusInput() {
            document.getElementById('txtEmail').focus();
        },

        onSelectHireType(e) {
            this.f2.hire_type = e.id;
        },

        onSelectUnit(e) {
            this.f2.unit_id = e.id;
        },

        onSelectWorkGroup(e) {
            this.f2.wg_id = e.id;
        },

        onSelectHireYear(e) {
            this.f2.hire_year = e.id;
        },

        openPopover(e) {
        },

        onSelectMonth(el, values) {
            let t = this;
            t.selectedMonth = new Date(values[0].replace('年', '') + '-' + values[1].replace('月', '') + '-01').format('yyyy-MM');
            t.loadAttData();
        },

        addAtt() {
            this.f2.att_config.push({
                start: '00:00',
                end: '00:00',
                showStart: false,
                showEnd: false,
                tomorrow: false
            });
        },

        removeAtt(item) {
            this.f2.att_config.remove(item);
        },

        selectDay(item) {

            let t = this;

            if (item.selected) {
                item.selected = false;
                t.f2.static_rest_day.remove(item);
            }
            else {
                item.selected = true;
                t.f2.static_rest_day.push(item);
            }

            let arr = [];

            t.f2.static_rest_day.forEach(item => {
                arr.push(item.text);
            });

            t.f2.static_rest_day_text = arr.join('、');
        },

        startUpload(field) {

            let t = this;

            FileUploader.onSelectFile = file => {

                if (t.busying)
                    return;

                t.busying = true;

                const formData = new FormData();

                formData.append('file', file);

                axios.post('employeeConfig/saveFile', formData, {
                    headers: {
                    }
                }).then(res => {

                    t.busying = false;

                    if (res.data.options.file_url)
                        t.f[field] = res.data.options.file_url;

                }).catch(error => {

                    t.busying = false;

                });

            };

            FileUploader.openSelector();

        },

        onSelectTomorrow(att) {
            if (att.tomorrow) {
                let arr = att.end.split(':');
                let hour = Number(arr[0]);
                if (hour > 10) {
                    att.end = '10:' + arr[1];
                }
            }
        },

        async saveConfig() {

            let t = this;

            if (t.busying)
                return;

            let form = mirror(t.f2);

            form.employee_id = t.item.id;

            let arr = [];
            form.static_rest_day.forEach(day => {
                arr.push(day.id);
            });

            form.static_rest_day = arr.join(',');
            delete form.static_rest_day_text;

            if (form.att_config.length < 1) {
                A.err('少なくとも一つの出退勤時間範囲を指定してください。');
                return;
            }

            let go = true;

            form.att_config.forEach((att, i) => {
                let d1 = new Date('2025-01-01 ' + att.start).valueOf();
                let d2 = new Date('2025-01-01 ' + att.end).valueOf();

                if (d1 >= d2 && !att.tomorrow) {
                    go = false;
                    A.err('出退勤_' + t.pad2(i + 1) + '「' + att.start + '-' + att.end + '」<br>出退勤の時間範囲が正しくありません。');
                }
            });

            if (!go) {
                return;
            }

            let attConfig = JSON.parse(JSON.stringify(form.att_config));

            let newAttConfig = [];

            attConfig.forEach(att => {
                newAttConfig.push({
                    start: att.start,
                    end: att.end,
                    tomorrow: att.tomorrow ? 1 : 0,
                });
            });

            form.att_config = JSON.stringify(newAttConfig);

            async function _save() {
                t.busying = true;
                let res = await axios.put('employeeConfig/' + form.id, form);
                t.busying = false;
                if (res.data.status == 0 || res.data.status == 1)
                    return true;
                else
                    return false;
            }

            if (t.config.static_rest_day && form.static_rest_day != pluck(t.config.static_rest_day, 'id').join(',')) {
                let res = await A.safety('定休日の変更は今月に反映されませんので、ご注意ください。<br><br>来月のシフトは自動的にリセットされるので、ご注意ください。')
                if (res.isConfirmed) {
                    form.static_rest_day_changed = 1;
                    return _save();
                }
            }
            else {
                return _save();
            }
        },

        async saveProfile() {
            let t = this;
            let f = t.f;

            if (t.busying) return;

            if (!f.lastname) {
                A.err("Lastname number is Required.");
                return;
            }

            if (!f.firstname) {
                A.err("Firstname number is Required.");
                return;
            }

            if (!f.tel) {
                A.err("Telephone number is Required.");
                return;
            }


            if (f.birthday_year && f.birthday_month && f.birthday_day) {

                let year = Number(f.birthday_year),
                    month = Number(f.birthday_month),
                    day = Number(f.birthday_day);

                const date = new Date(year, month - 1, day);

                if (date instanceof Date &&
                    !isNaN(date.getTime()) &&
                    date.getDate() === day &&
                    date.getMonth() === month - 1 &&
                    date.getFullYear() === year) {
                    f.birthday = f.birthday_year + '/' + f.birthday_month + '/' + f.birthday_day;
                }
                else {
                    A.err('Birthday is not Valid.');
                    return;
                }
            }
            else {
                A.err('Birthday is not Valid.');
                return;
            }

            if (!f.email) {
                A.err("Email is Required.");
                return;
            }

            if (!/^[a-zA-Z0-9\.]{1,}@[a-zA-Z0-9\.]{1,}[a-zA-Z0-9]$/.test(f.email)) {
                A.err("Please enter a valid email address.");
                return;
            }

            if (!f.emergency_tel) {
                A.err("Emergency telephone number is Required.");
                return;
            }

            if (!f.emergency_contact_name) {
                A.err('Emergency contact name is Required.');
                return;
            }

            if (!f.address) {
                A.err("Address is Required.");
                return;
            }

            let data = getFields(f, [
                "firstname",
                "lastname",
                "address",
                "email",
                "tel",
                "emergency_tel",
                "emergency_contact_name",
                "gender",
                "birthday",
                "desc",
                "code1",
                "code2",
                "country"
            ]);

            let fd = new FormData();

            for (const key in data) {
                fd.append(key, data[key]);
            }

            fd.append('id', t.item.id);

            if (t.rcIsUploaded) fd.append("rc_image", t.rcImageBlob);

            if (t.avatarIsUploaded) fd.append("avatar_image", t.avatarImageBlob);

            t.busying = true;

            let res = await axios
                .post("employee/saveProfile", fd, {
                    headers: { "Content-Type": "multipart/form-data" },
                });

            t.busying = false;

            t.avatarImageBlob = null;
            t.avatarIsUploaded = false;
            t.rcImageBlob = null;
            t.rcIsUploaded = false;

            if (res.data.status == 1) {
                return true;
            }

            return false;
        },

        async saveEditing() {

            let t = this;

            if (!await t.saveProfile()) return;

            if (!await t.saveConfig()) return;

            A.toast('変更が保存されました。');

            t.$emit('save');

        },

        getSixMonthsAgo(now) {

            now = new Date(now);

            now.setMonth(now.getMonth() - 5);

            const year = now.getFullYear();
            const month = String(now.getMonth() + 1).padStart(2, '0');

            return `${year}-${month}`;
        },

        generateDateDict(startMonth, endMonth) {
            // 将输入的 "yyyy/MM" 格式转换为 Date 对象
            function parseMonth(monthStr) {
                const [year, month] = monthStr.split('-').map(Number);
                return new Date(year, month - 1, 1); // 月份从0开始，所以减1
            }

            const startDate = parseMonth(startMonth);
            const endDate = parseMonth(endMonth);

            const result = {};

            // 遍历每个月
            let currentDate = new Date(startDate);
            while (currentDate <= endDate) {
                const year = currentDate.getFullYear();
                const month = String(currentDate.getMonth() + 1).padStart(2, '0');
                const daysInMonth = new Date(year, currentDate.getMonth() + 1, 0).getDate();

                // 为该月的每一天创建键值对
                for (let day = 1; day <= daysInMonth; day++) {
                    const dateKey = `${year}-${month}-${String(day).padStart(2, '0')}`;
                    result[dateKey] = null; // 默认值设为 null，你可以根据需要修改
                }

                // 移动到下一个月
                currentDate.setMonth(currentDate.getMonth() + 1);
            }

            return result;
        },

        extractMonthData(dateDict, targetMonth) {
            const targetPrefix = targetMonth + '-';
            const result = {};

            for (const key in dateDict) {
                if (key.startsWith(targetPrefix)) {
                    let value = dateDict[key];
                    result[key] = value;
                }
            }
            return result;
        },

        async loadAttData() {

            let t = this;

            let params = {
                'start_date': t.selectedMonth,
                'end_date': t.selectedMonth,
                'employee_id': t.item.id
            };

            t.dateCell = t.generateDateDict(params.start_date, params.end_date);

            t.initDateCell(t.dateCell);

            await t._loadAttData(params, t.dateCell);

            t.monthCell = t.extractMonthData(t.dateCell, t.selectedMonth);

            t.monthStats = t.calcMonthStats(t.monthCell);

            setTimeout(() => {
                t.initPieChart();
            });

            let days = new Date(t.selectedMonth + '-01').getDay();

            t.list.placeholder = [];

            if (days == 0) {
                days = 6;
            } else {
                days--;
            }

            for (let j = 0; j < days; j++) {
                t.list.placeholder.push("");
            }

        },

        initPieChart() {

            let t = this;

            let chartDom = document.getElementById('pieChart');
            let myChart = echarts.init(chartDom);
            let option;

            let data = [
                { value: t.monthStats.total_work_hours, },
                { value: t.monthStats.late_minutes / 60, },
                { value: t.monthStats.overtime_hours, },
                { value: (t.monthStats.paid_leave_days + t.monthStats.unpaid_leave_days) * 8, },
            ];

            data.forEach(item => {
                item.value = Math.round(item.value * 100) / 100;
            });

            option = {
                tooltip: {
                    trigger: 'item',
                    // 在 simple 版本中，formatter 只能返回字符串，不能返回 HTML。
                    formatter: '{c}時間' // {b} 是名称，{c} 是数值
                },
                series: [
                    {
                        type: 'pie',
                        radius: '80%',
                        color: ['#A2C2CC', '#FCEFDF', '#FFB3B3', '#999999'],
                        data: data,
                        label: {
                            show: false
                        },
                        emphasis: {
                            itemStyle: {
                                shadowBlur: 10,
                                shadowOffsetX: 0,
                                shadowColor: 'rgba(0, 0, 0, 0.1)'
                            }
                        }
                    }
                ]
            };

            option && myChart.setOption(option);

        },

        calcMonthStats(monthCell) {

            let t = this;

            let s = mirror(t.monthStats);

            for (const key in s) {
                s[key] = 0;
            }

            let attDays = 0;

            for (const date in monthCell) {
                let item = monthCell[date];

                if (item.dynamic_rest == 1) {

                    if (item.shift) {
                        s.dynamic_rest_day_req++;
                    }
                    else {
                        s.dynamic_rest_day++;
                    }
                }

                if (item.work == 1 || item.work == 2 || item.rest_to_work == 1) {
                    attDays++;
                }


                if (item.clock_in && item.clock_out) {

                    let clock_in = new Date(item.clock_in.date + " " + item.clock_in.time);
                    let clock_out = new Date(item.clock_out.date + " " + item.clock_out.time);


                    if (item.clock_in.day == 1) {
                        clock_in.setDate(clock_in.getDate() - 1);
                    }

                    if (item.schedule) {

                        let start = new Date(item.full_date + " " + item.schedule.start_time);
                        let end = new Date(item.full_date + " " + item.schedule.end_time);

                        if (start.valueOf() + 10 * 60 * 1000 < clock_in.valueOf()) {
                            item.is_late = true;
                            s.late_times++;
                            s.late_minutes += Math.floor(
                                (clock_in.valueOf() - start.valueOf()) / 60.0 / 1000
                            );
                        }

                        if (end.valueOf() > clock_out.valueOf()) {
                            item.is_early = true;
                            s.early_times++;
                        }

                        let overtimeHours = Math.floor(
                            (clock_out.valueOf() - end.valueOf()) / 60.0 / 60.0 / 1000
                        );

                        if (overtimeHours >= 0) {
                            s.overtime_hours += overtimeHours;
                        }

                    }

                    s.night_work_hours += calculateOvernightHours(clock_in, clock_out);

                    let hour = Number(((clock_out - clock_in - 60 * 60.0 * 1000.0) / 1000.0 / 60 / 60).toFixed(1));

                    item.daily_working_hour = hour;

                    s.total_work_hours += hour;

                    s.total_work_day++;
                }

                if (item.fieldWorks.length > 0) {
                    s.field_work += item.fieldWorks.length;
                }

                if (item.leave && item.leave.type == 1) {
                    if (item.leave.rest_pm == 1) {
                        s.paid_leave_days += 0.5;
                    }
                    if (item.leave.rest_am == 1) {
                        s.paid_leave_days += 0.5;
                    }
                }

                if (item.leave && item.leave.type == 2) {

                    if (item.leave.rest_pm == 1) {
                        s.unpaid_leave_days += 0.5;
                    }
                    if (item.leave.rest_am == 1) {
                        s.unpaid_leave_days += 0.5;
                    }
                }
            }

            s.shift_achievement_rate = Math.round((s.total_work_day / attDays) * 100);

            for (const key in s) {
                if (typeof s[key] == 'number') {
                    s[key] = Math.round(s[key] * 100) / 100;
                }
            }

            return s;
        },

        initDateCell(dateCell) {

            let t = this;

            for (const date in dateCell) {
                let staticRest = false;
                let hasConfig = true;
                let days = pluck(t.config.static_rest_day, 'id');
                staticRest = days.indexOf((new Date(date)).getDay()) > -1;

                let entryDate = new Date(t.item.entry_date);
                let curDate = new Date(date);

                dateCell[date] = {
                    month: Number(curDate.format('MM')),
                    full_date: date,
                    date: curDate.format('MM/dd'),
                    day_index: curDate.getDay(),
                    day_text: ['日', '月', '火', '水', '木', '金', '土'][curDate.getDay()],
                    hasConfig: hasConfig,
                    hasReview: false,
                    beforeEntry: curDate < entryDate,
                    hasScheduleReview: false,
                    static_rest: staticRest,
                    leave: null,
                    fieldWork: null,
                    fieldWorks: [],
                    shift: null,
                    sup: null,
                    start_time: '',
                    end_time: '',
                    rest_am: false,
                    rest_pm: false,
                    work: 0,
                    rest_to_work: 0,
                    rest_date: '',
                    dynamic_rest: false,
                    work_date: '',
                    clockIns: [],
                    clock_in: null,
                    clock_out: null,
                    schedule: null,
                };
            }

        },

        async _loadAttData(params, dateCell) {
            let t = this;
            return await axios.get('clockIn/attTable', { params: params }).then(res => {
                if (res.data.status == 1) {
                    res.data.options.sup.forEach(item => {

                        if (!dateCell[item.date]) {
                            return;
                        }

                        if (dateCell[item.date]) {
                            dateCell[item.date].sup = item;
                            if (item.status == 0)
                                dateCell[item.date].hasReview = true;
                        }
                    });
                    res.data.options.field_work.forEach(item => {

                        if (!dateCell[item.date]) {
                            return;
                        }

                        if (dateCell[item.date]) {
                            // dateCell[item.date].fieldWork = item;
                            if (item.clock_in == 1) {
                                dateCell[item.date].fieldWork_clock_in = 1;
                            }
                            if (item.clock_out == 1) {
                                dateCell[item.date].fieldWork_clock_out = 1;
                            }
                            dateCell[item.date].fieldWorks.push(item);
                            if (item.status == 0)
                                dateCell[item.date].hasReview = true;
                        }
                    });
                    res.data.options.schedule.forEach(item => {
                        let schedule = JSON.parse(item.data);
                        schedule.forEach(dateItem => {

                            if (!dateCell[dateItem.date]) {
                                return;
                            }

                            let cellItem = dateCell[dateItem.date];

                            if (cellItem) {
                                cellItem.schedule = dateItem;
                                cellItem.start_time = dateItem.start_time;
                                cellItem.end_time = dateItem.end_time;
                                cellItem.work = dateItem.work;
                                cellItem.rest_to_work = dateItem.rest_to_work;
                                cellItem.rest_date = dateItem.rest_date;

                                cellItem.rest_am = dateItem.rest_am;
                                cellItem.rest_pm = dateItem.rest_pm;
                                cellItem.static_rest = false;

                                if (cellItem.rest_to_work == 1) {
                                    let cellItem2 = dateCell[dateItem.rest_date];

                                    if (cellItem2) {
                                        cellItem2.dynamic_rest = true;
                                        cellItem2.work_date = dateItem.date;
                                    }
                                }
                            }
                        });
                    });
                    res.data.options.shift.forEach(item => {

                        if (dateCell[item.date]) {
                            let dateItem = dateCell[item.date];
                            let restDateItem = dateCell[item.rest_date];
                            dateItem.shift = item;
                            if (item.status == 0)
                                dateItem.hasReview = true;
                            dateItem.static_rest = 0;
                            dateItem.rest_to_work = 1;
                            dateItem.rest_date = item.rest_date;
                            if (restDateItem.start_time) {
                                dateItem.start_time = restDateItem.start_time;
                                dateItem.end_time = restDateItem.end_time;
                            }
                            restDateItem.dynamic_rest = true;
                            restDateItem.work_date = item.date;
                        }
                    });
                    res.data.options.leave.forEach(item => {

                        if (dateCell[item.date]) {
                            item.leave_data = JSON.parse(item.leave_data);
                            let dateItem = dateCell[item.date];
                            if (item.status == 0)
                                dateItem.hasReview = true;
                            dateItem.leaveReq = item;
                            item.leave_data.forEach(leaveData => {
                                if (dateCell[leaveData.date]) {
                                    let leaveDateItem = dateCell[leaveData.date];
                                    if (leaveDateItem) {
                                        leaveDateItem.leave = leaveData;
                                        leaveDateItem.leave.type = item.type;
                                        leaveDateItem.leave.timespan = item.timespan;
                                    }
                                }
                            });
                        }
                    });
                    res.data.options.clock_in.forEach(item => {
                        if (!dateCell[item.date]) {
                            return;
                        }

                        if (dateCell[item.date]) {
                            dateCell[item.date].clockIns.push(item);
                        }
                    });

                    for (const date in dateCell) {

                        let d = dateCell[date];

                        let cellItem = d;

                        if (cellItem.clockIns.length > 0) {

                            let toRemove = [];

                            let dict = {};

                            cellItem.clockIns.forEach(clockData => {
                                if (!dict[clockData.type]) {
                                    dict[clockData.type] = clockData;
                                }
                                else {
                                    if (clockData.sup_id && !dict[clockData.type].sup_id) {
                                        toRemove.push(dict[clockData.type]);
                                    }
                                    else if (!clockData.sup_id && dict[clockData.type].sup_id) {
                                        toRemove.push(clockData);
                                    }
                                    else if (clockData.sup_id && dict[clockData.type].sup_id) {

                                        if (clockData.sup_id > dict[clockData.type].sup_id) {
                                            toRemove.push(dict[clockData.type]);
                                        }
                                        else {
                                            toRemove.push(clockData);
                                        }
                                    }
                                }
                            });

                            toRemove.forEach(_item => {
                                cellItem.clockIns.remove(_item);
                            });

                            cellItem.clockIns.forEach(clockData => {
                                if (clockData.type == 1 && clockData.time) {
                                    cellItem.start_time = clockData.time.substr(0, 5);
                                    cellItem.clock_in = clockData;
                                }
                                else if (clockData.type == 2 && clockData.time) {
                                    cellItem.end_time = clockData.time.substr(0, 5);
                                    cellItem.clock_out = clockData;
                                }
                            });
                        }
                    }
                }
            });
        },

        async loadHalfYearAttData() {

            let t = this;

            let params = {
                'start_date': t.getSixMonthsAgo(t.year + '-' + t.month),
                'end_date': t.year + '-' + t.month,
                'employee_id': t.item.id
            };

            t.dateCell2 = t.generateDateDict(params.start_date, params.end_date);

            t.initDateCell(t.dateCell2);

            await t._loadAttData(params, t.dateCell2);

            let halfYearStats = [];
            let monthTexts = [];

            for (let i = 0; i < 6; i++) {
                let d = new Date(params.start_date + '-01');
                d.setMonth(d.getMonth() + i);
                monthTexts.push(d.format('M月'));
                let monthCell = t.extractMonthData(t.dateCell2, d.format('yyyy-MM'));
                let stats = t.calcMonthStats(monthCell);
                halfYearStats.push(stats);
            }

            setTimeout(() => {
                t.initLineChart(halfYearStats, monthTexts);
            }, 100);
        },

        initLineChart(halfYearStats, monthTexts) {

            let data1 = [], data2 = [], data3 = [], data4 = [];

            let chartDom = document.getElementById('lineChart');

            let myChart = echarts.init(chartDom);
            let option;

            halfYearStats.forEach(item => {
                data1.push(Math.round(item.total_work_hours * 100) / 100);
                data2.push(Math.round(item.overtime_hours * 100) / 100);
                data3.push(Math.round(item.late_minutes / 60 * 100) / 100);
                data4.push(Math.round((item.paid_leave_days + item.unpaid_leave_days) * 8 * 100) / 100);
            });

            let max = Math.max(...data1);

            if (max < 250)
                max = 250;

            option = {
                // 配置提示框（tooltip）
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        type: 'shadow'
                    },
                    formatter: function (params) {
                        let result = `${params[0].name}<br/>`; // 显示月份
                        params.forEach(function (item) {
                            result += `${item.seriesName}: ${item.value}時間<br/>`;
                        });
                        return result;
                    }
                },

                // 配置X轴
                xAxis: {
                    type: 'category',
                    data: monthTexts,
                    axisLine: {
                        lineStyle: {
                            color: '#ddd'
                        }
                    },
                    axisLabel: {
                        color: '#999'
                    },
                    splitLine: {
                        show: false
                    }
                },

                // 配置Y轴
                yAxis: {
                    type: 'value',
                    name: '',
                    nameGap: 10,
                    nameTextStyle: {
                        color: '#999',
                        fontSize: 14
                    },
                    axisLine: {
                        lineStyle: {
                            color: '#ddd'
                        }
                    },
                    axisLabel: {
                        color: '#999',
                        formatter: '{value}時間'
                    },
                    splitLine: {
                        lineStyle: {
                            color: '#eee'
                        }
                    },
                    min: 0,
                    max: max,
                    interval: 50
                },

                // 配置系列数据
                series: [
                    // --- A组堆叠 ---
                    {
                        name: '実際の出勤時間',
                        type: 'bar',
                        stack: 'stackA', // 第一组堆叠，命名为 'stackA'
                        barWidth: '25%', // 控制每组柱子的总宽度
                        itemStyle: {
                            color: '#A2C2CC', // 浅蓝色
                            borderRadius: [2, 2, 0, 0]
                        },
                        data: data1
                    },
                    {
                        name: '残業時間',
                        type: 'bar',
                        stack: 'stackA', // 与上一个系列共享 'stackA'，实现堆叠
                        itemStyle: {
                            color: '#FFB3B3', // 浅粉色
                            borderRadius: [2, 2, 0, 0]
                        },
                        data: data2
                    },

                    // --- B组堆叠 ---
                    {
                        name: '遅刻した時間',
                        type: 'bar',
                        stack: 'stackB', // 第二组堆叠，命名为 'stackB'
                        barWidth: '25%', // 控制每组柱子的总宽度
                        itemStyle: {
                            color: '#FCEFDF', // 浅灰色
                            borderRadius: [2, 2, 0, 0]
                        },
                        data: data3
                    },
                    {
                        name: '休暇を申請した時間',
                        type: 'bar',
                        stack: 'stackB', // 与上一个系列共享 'stackB'，实现堆叠
                        itemStyle: {
                            color: '#999999', // 米白色
                            borderRadius: [2, 2, 0, 0]
                        },
                        data: data4 // B组学习数据
                    }
                ]
            };

            option && myChart.setOption(option);

        },



        loadMonthlyStats() {

            let t = this;

            let dayIndexs = ['日', '月', '火', '水', '木', '金', '土'];

            t.dictWaitingTask = {};

            t.list.dateGrid.clear();

            axios.get('group').then(res => {
                if (res.data.status == 1) {

                    let arr = res.data.options.items;

                    let dictRoomGroup = {};

                    arr.forEach(group => {

                        let roomIds = group.room_ids = group.room_ids.split(',');

                        roomIds.forEach(roomId => {
                            dictRoomGroup[roomId] = group;
                        });
                    });

                    axios.post('cleanTask/readMonthly/' + t.year + '/' + t.month + "?eid=" + t.item.id + '&_with=waiting').then(res => {
                        if (res.data.status == 1) {

                            let dictDate = {};

                            let todayText = (new Date()).format('MM/dd');
                            let todayVal = new Date();

                            let startDate = new Date(res.data.options.start_date);
                            let endDate = new Date(res.data.options.end_date);

                            let i = 0;

                            let days = new Date(startDate).getDay();

                            t.list.placeholder = [];

                            for (let j = 0; j < days; j++) {
                                t.list.placeholder.push('');
                            }

                            while (true) {
                                let curDate = new Date(res.data.options.start_date);
                                curDate.setDate(curDate.getDate() + i);
                                if (curDate > endDate)
                                    break;
                                let date = curDate.format('MM/dd');
                                let dayIndex = dayIndexs[curDate.getDay()];
                                let item = {
                                    date: date,
                                    day_index: dayIndex,
                                    week_index: curDate.getDay(),
                                    tasks: [],
                                    is_today: date == todayText,
                                    is_past: curDate < todayVal
                                };
                                dictDate[date] = item;
                                t.list.dateGrid.push(item);
                                i++;
                            }

                            let arr = res.data.options.items;

                            arr.forEach(task => {
                                let date = new Date(task.date).format('MM/dd');
                                let item = dictDate[date];
                                if (task.cleaner_id == t.item.id) {
                                    item.tasks.push(task);
                                }
                                else {
                                    if (!t.dictWaitingTask[date])
                                        t.dictWaitingTask[date] = [];

                                    t.dictWaitingTask[date].push(task);
                                }
                            });

                            let groupIds = localStorage['selected_group_ids'];

                            if (groupIds) {
                                groupIds = groupIds.split(',');
                            }


                            t.list.dateGrid.forEach(item => {

                                let groups = [];

                                item.tasks.forEach(task => {
                                    let roomId = task.room_id;
                                    let group = dictRoomGroup[roomId];
                                    if (groups.indexOf(group) < 0)
                                        groups.push(group);
                                });

                                let dictGroup = listToDict(groups);

                                if (groups.length > 0 && groupIds.length > 0) {

                                    let notIn = [];

                                    groups.forEach(group => {
                                        if (groupIds.indexOf(group.id.toString()) < 0) {
                                            notIn.push(group.id);
                                        };
                                    })

                                    let arr2 = [];

                                    groupIds.forEach(groupId => {
                                        if (dictGroup[groupId])
                                            arr2.push(dictGroup[groupId]);
                                    });

                                    notIn.forEach(groupId => {
                                        if (dictGroup[groupId])
                                            arr2.push(dictGroup[groupId]);
                                    });

                                    groups = arr2;

                                }

                                item.tasks.forEach(task => {
                                    let roomId = task.room_id;
                                    let group = dictRoomGroup[roomId];
                                    let i1 = groups.indexOf(group) + 1 * 1000;
                                    let i2 = group.room_ids.indexOf(roomId.toString()) + 1;
                                    task.index = i1 + i2;
                                });

                                item.tasks = item.tasks.sort((a, b) => {
                                    return a.index - b.index;
                                });

                            });

                        }
                    });



                }
            });


        },

        minusMonth() {
            let t = this;
            let r = addMonthsToDate(new Date(t.year, t.month - 1, 1), -1);
            t.month = r.getMonth() + 1;
            t.year = r.getFullYear();
            t.loadMonthlyStats();
        },

        plusMonth() {
            let t = this;
            let r = addMonthsToDate(new Date(t.year, t.month - 1, 1), 1);
            t.month = r.getMonth() + 1;
            t.year = r.getFullYear();
            t.loadMonthlyStats();
        },

        editDateGrid(item) {

            if (item.is_past)
                return;

            let t = this;

            t.currentItem = item;
            t.selectedTask = null;
            t.showCleanTaskEditor = true;
            t.list.task = t.dictWaitingTask[item.date];
        },

        removeItem(item) {

            let t = this;

            if (t.busying)
                return;

            t.busying = true;

            A.safety('Are you sure to delete this clean task?').then(res => {

                t.busying = false;

                if (res.isConfirmed) {

                    let f = {
                        id: item.order_id,
                        cleaner_id: null,
                    };

                    axios.post('order/setCleaner', f).then(res => {

                        t.busying = false;

                        if (res.data.status == 1) {
                            A.toast('Saved.');
                            t.currentItem.tasks.remove(item);
                            t.$forceUpdate();
                        }
                    });

                }
            });
        },

        addTask() {
            let t = this;

            if (t.busying)
                return;

            t.busying = true;

            let item = t.selectedTask;

            t.currentItem.tasks.push(t.selectedTask);

            t.dictWaitingTask[t.currentItem.date].remove(t.selectedTask);

            t.selectedTask = null;

            let f = {
                id: item.order_id,
                cleaner_id: t.item.id,
                clean_status: 1,
            };

            axios.post('order/setCleaner', f).then(res => {

                t.busying = false;

                if (res.data.status == 1) {

                    A.toast('Saved.');
                    item.cleaner_id = t.item.id;
                    item.status = 1;
                    t.$forceUpdate();
                }
            });

        },

    },
    data() {
        return {

            today: Date.today(),

            view: 'profile',

            year: Date.today().getFullYear(),
            month: Date.today().getMonth() + 1,

            thisMonth: Date.today().format('yyyy-MM'),
            selectedMonth: Date.today().format('yyyy-MM'),

            editName: false,

            f: {
                firstname: '',
                lastname: '',
                gender: 1,
                address: '',
                email: '',
                tel: '',
                birthday: '',
                emergency_tel: '',
                emergency_contact_name: '',
                desc: '',
                rc_img_url: '',
                avatar_url: '',
                id: '',
                country: '',
                code1: '',
                code2: '',
                birthday_year: '',
                birthday_month: '',
                birthday_day: ''
            },
            rcIsUploaded: false,
            rcImageBlob: null,
            avatarIsUploaded: false,
            avatarImageBlob: null,
            cropper: null,
            uploadImgType: "",

            list: {
                task: [],
                country: [],
                dateGrid: [],
                placeholder: []
            },

            dict: {
                country: {},
                hire_type: {},
                hire_type2: {},
                hire_year: {},
                rest_day: {},
                unit: {},
                workGroup: {}
            },

            showCountryPopover: false,

            f2: {
                work_online: 0,
                unit_id: null,
                wg_id: null,
                hire_type: 1,
                hire_year: 1,
                att_config: [
                    {
                        start: '00:00',
                        end: '00:00',
                        showStart: false,
                        showEnd: false,
                    }
                ],
                static_rest_day: [],
                static_rest_day_text: '',
                year_rest_day: 7,
                monthly_dynamic_rest_day: 8,
                monthly_att_modify_times: 6,
                monthly_field_work_times: 14,
                contract_url: "",
                insurance_url: "",
                remark: "",
            },

            p: {
                hire_type: false,
                hire_year: false,
                rest_day: false,
                static_rest_day: false,
                month: false
            },

            options: {
                hire_type: [
                    { id: 1, text: "正社員" },
                    { id: 2, text: "バイト" },
                ],
                hire_type2: [
                    { id: 2, text: "バイト" },
                    { id: 3, text: "業務委託" },
                ],
                hire_year: [
                    { id: 1, text: "1年" },
                    { id: 2, text: "2年" },
                    { id: 3, text: "3年" },
                    { id: 4, text: "4年" },
                    { id: 5, text: "5年" },
                    { id: 99, text: "無期限" },
                ],
                rest_day: [
                    { id: 1, text: "月" },
                    { id: 2, text: "火" },
                    { id: 3, text: "水" },
                    { id: 4, text: "木" },
                    { id: 5, text: "金" },
                    { id: 6, text: "土" },
                    { id: 0, text: "日" },
                ],
                unit: [],
                workGroup: [],
            },

            attendanceExpanded: true,
            selectedTask: null,
            currentItem: null,
            showTaskPopover: false,
            showCleanTaskEditor: false,
            dictWaitingTask: {},

            dateCell: {},
            dateCell2: {},
            monthCell: {},
            monthStats: {
                dynamic_rest_day: 0,
                dynamic_rest_day_req: 0,
                total_work_hours: 0,
                night_work_hours: 0,
                overtime_hours: 0,
                total_work_day: 0,
                late_times: 0,
                late_minutes: 0,
                special_leave_time: 0,
                paid_leave_days: 0,
                unpaid_leave_days: 0,
                shift_achievement_rate: 0,
                field_work: 0,
                early_times: 0,
            },

            monthColumns: [
                {
                    values: [
                        '2025年'
                    ],
                    defaultIndex: 0,
                },
                {
                    values: [
                        '1月',
                        '2月',
                        '3月',
                        '4月',
                        '5月',
                        '6月',
                        '7月',
                        '8月',
                        '9月',
                        '10月',
                        '11月',
                        '12月',
                    ],
                    defaultIndex: new Date().getMonth(),
                },
            ],
        };
    },
    computed: {
    }
};
